import { addAdditionalDocument } from 'api/operations/documentsService';
import { action, makeObservable } from 'mobx';
import { uploadFiles } from 'global/utils/uploadFiles';
import { DocumentContextualProps, DocumentStaticDataStore } from './documentStaticDataStore';

interface CreateDocumentContextualProps extends DocumentContextualProps {
  entityId: string;
}

export class RequestDocumentModalStore extends DocumentStaticDataStore {
  private readonly _entityId: string;

  protected async _processDocumentAction(): Promise<void> {
    const fileURL = await addAdditionalDocument({
      entityId: this._entityId,
      type: this.form.fields.docName.value.trim(),
      description: this.form.fields.description.value.trim(),
      templateLink: this.uploadedFile ? '' : this.form.fields.templateLink.value.trim(),
      fileName: this.uploadedFile ? Object.keys(this.uploadedFile)[0] : '',
    });

    if (this.uploadedFile && fileURL) {
      const uploadedFileName = Object.keys(this.uploadedFile)[0];
      await uploadFiles(this.uploadedFile, { [uploadedFileName]: fileURL });
    }
  }

  constructor(props: CreateDocumentContextualProps) {
    super(props);
    this._entityId = props.entityId;
    makeObservable<RequestDocumentModalStore, '_processDocumentAction'>(this, {
      _processDocumentAction: action.bound,
    });
  }
}
